/* eslint-disable no-restricted-syntax */
import { useCallback, useEffect, useState } from 'react';

function useCamera() {
    const [mediaStream, setMediaStream] = useState<MediaStream | null>(null);

    // const getDevice = (devices: MediaDeviceInfo[]) => {
    //     for (const device of devices) {
    //         if (
    //             device.label.includes('facing back') &&
    //             device.label.includes('camera2 0')
    //         ) {
    //             return device.deviceId;
    //         }
    //     }
    //     return null;
    // };

    const startCamera = async () => {
        // const devices = await navigator.mediaDevices?.enumerateDevices();
        // console.log('273 devices', devices);
        // const selectedDeviceId = getDevice(devices);
        // const mediaConstraints = selectedDeviceId
        //     ? {
        //           video: {
        //               deviceId: {
        //                   exact: selectedDeviceId,
        //               },
        //               frameRate: {
        //                   ideal: 30,
        //               },
        //           },
        //       }
        //     : {
        //           video: {
        //               facingMode: {
        //                   ideal: 'environment',
        //               },
        //               frameRate: {
        //                   ideal: 30,
        //               },
        //           },
        //       };
        // console.log('273 mediaConstraints', mediaConstraints);
        const stream = await navigator.mediaDevices.getUserMedia({
            video: {
                facingMode: {
                    ideal: 'environment',
                },
                frameRate: {
                    ideal: 30,
                },
            },
        });
        setMediaStream(stream);
    };

    const stopCamera = useCallback(() => {
        const tracks = mediaStream?.getTracks();
        tracks?.forEach((track) => track.stop());
        console.log('273 tracks', tracks);
        console.log('273 mediaStream', mediaStream);
    }, [mediaStream]);

    useEffect(
        // Shut down the camera on unmount.
        () => stopCamera,
        [stopCamera]
    );

    // useEffect(() => {
    //     (async () => {
    //         try {
    //             const permission = await navigator.permissions.query({
    //                 name: 'camera' as PermissionName,
    //             });
    //             if (
    //                 permission.state === 'granted' ||
    //                 permission.state === 'prompt'
    //             ) {
    //                 startCamera();
    //             } else {
    //                 permission.onchange = () => {
    //                     if (permission.state === 'granted') {
    //                         startCamera();
    //                     }
    //                 };
    //             }
    //         } catch (err) {
    //             console.error('error encountered starting camera: ', err);
    //         }
    //     })();
    // }, []);

    return {
        mediaStream,
        startCamera,
        stopCamera,
    };
}

export default useCamera;
